var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 162,
    viewBox: "0 0 94 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M89.2025 50.5083L-11.2837 156.874C-9.58099 157.494 -7.86237 158.054 -6.12455 158.536L90.7726 55.9693C90.3168 54.1298 89.7881 52.3106 89.2025 50.5083Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M85.1842 40.5183L-20.7222 152.622C-19.2204 153.442 -17.6944 154.201 -16.1441 154.899L87.3354 45.3643C86.6738 43.7265 85.9567 42.1112 85.1842 40.5183Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M91.9839 61.8076L-0.608887 159.816C1.34558 160.19 3.31398 160.48 5.29627 160.688L92.808 68.0583C92.6115 65.961 92.3368 63.8774 91.9839 61.8076Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M80.1002 31.6582L-29.0923 147.24C-27.7632 148.235 -26.4037 149.167 -25.0237 150.055L82.7589 35.9649C81.9208 34.5041 81.0403 33.065 80.1002 31.6582Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M11.6514 161.085C13.959 161.121 16.2725 161.053 18.5854 160.867L92.9744 82.125C93.1507 79.676 93.2143 77.2278 93.1805 74.7852L11.6514 161.085Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M15.6026 0.226839L-58.7865 78.9708C-58.9627 81.4198 -59.025 83.8687 -58.9912 86.3106L22.5366 0.00873127C20.2297 -0.0256324 17.9161 0.040293 15.6026 0.226839Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M35.1444 157.583L89.8695 99.6555C90.7454 96.5802 91.4533 93.454 91.9896 90.2925L26.3003 159.826C29.2865 159.258 32.2395 158.509 35.1444 157.583Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M74.0491 23.8184L-36.4976 140.835C-35.3295 141.992 -34.1416 143.111 -32.9199 144.167L77.1928 27.611C76.199 26.3136 75.1423 25.0555 74.0491 23.8184Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M-0.956059 3.51235L-55.6812 61.4397C-56.5575 64.5149 -57.2653 67.6411 -57.8013 70.8027L7.88807 1.271C4.90175 1.83742 1.9488 2.58578 -0.956059 3.51235Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M28.893 0.402588L-58.6201 93.0379C-58.4236 95.1348 -58.1488 97.2184 -57.7959 99.2886L34.7968 1.27501C32.8423 0.900045 30.8744 0.609237 28.893 0.402588Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M69.3558 135.866C76.1352 128.704 81.6774 120.34 85.7316 111.155L46.0122 153.2C54.6895 148.909 62.5899 143.042 69.3558 135.866Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M59.2143 11.0386L-48.5723 125.129C-47.7335 126.59 -46.8497 128.029 -45.9129 129.436L63.2809 13.8536C61.9506 12.8591 60.591 11.9264 59.2143 11.0386Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M40.3124 2.55908L-56.5835 105.124C-56.1283 106.965 -55.599 108.783 -55.0146 110.585L45.4708 4.21906C43.7701 3.60051 42.0515 3.04087 40.3124 2.55908Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M67.1059 16.9268L-43.0068 133.483C-42.0077 134.779 -40.953 136.038 -39.8591 137.274L70.6862 20.2586C69.5189 19.1029 68.3296 17.9843 67.1059 16.9268Z",
    fill: "#474A88"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M50.3307 6.19482L-53.1475 115.731C-52.4849 117.367 -51.7678 118.982 -50.9962 120.575L54.9101 8.47405C53.407 7.65212 51.8806 6.89238 50.3307 6.19482Z",
    fill: "#474A88"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightDesign);
export default __webpack_public_path__ + "static/media/right-design.2c012b3bf5a32dee00d3cc9638119640.svg";
export { ForwardRef as ReactComponent };